import script from "./watchChar.vue?vue&type=script&setup=true&lang=ts"
export * from "./watchChar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__